import { FC, useContext, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";

import { Modal } from "capitalrx-components-2.0/lib/general";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

import { AuthenticationContext } from "@/context";

// 1000 (milliseconds) * 60 (seconds) * 15 (minutes)]
export const userTimeoutMs = 1000 * 60 * 15;

// Show idle timer modal when 60 seconds remain before timeout
export const showIdleTimerWithSecondsLeft = 60;

export const AutoLogout: FC = () => {
  const [showIdleTimerModal, setShowIdleTimerModal] = useState<boolean>(false);
  const [remainingTime, setRemainingTime] = useState<number>(userTimeoutMs);
  const { logoutUser } = useContext(AuthenticationContext);

  const onIdle = () => {
    handleLogout();
  };

  const onActive = () => {
    setShowIdleTimerModal(false);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    name: "hcpIdleLogoutTimer",
    timeout: userTimeoutMs,
    events: ["mousedown", "keydown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove"],
    throttle: 500,
    crossTab: true,
    syncTimers: 200,
  });

  useEffect(() => {
    if (remainingTime && remainingTime < showIdleTimerWithSecondsLeft) {
      setShowIdleTimerModal(true);
    } else {
      setShowIdleTimerModal(false);
    }
  }, [remainingTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const handleLogout = async (): Promise<void> => {
    await logoutUser();
  };

  return (
    <>
      {showIdleTimerModal && (
        <Modal visible={true} title="Session Timeout">
          <Paragraph>You will be timed out for inactivity in {remainingTime} seconds, click anywhere to resume your session.</Paragraph>
        </Modal>
      )}
    </>
  );
};
